// extracted by css-extract-rspack-plugin
export default {"main":"r5W7UU5___main","content":"cEU8v3V___content"};